var map = {
	"./audio/start.png": 47406,
	"./audio/stop.png": 68414,
	"./btn_back.png": 5740,
	"./callme/android.png": 94256,
	"./callme/avatar.png": 56983,
	"./callme/empty.png": 69924,
	"./callme/home.png": 13267,
	"./callme/ios.png": 99737,
	"./callme/logo.png": 79832,
	"./callme_logo.png": 13942,
	"./caramel/android.png": 18310,
	"./caramel/avatar.png": 57758,
	"./caramel/empty.png": 55585,
	"./caramel/home.png": 83525,
	"./caramel/ios.png": 5230,
	"./caramel/logo.png": 2685,
	"./charmIcon/star_icon_0@2x.png": 50221,
	"./charmIcon/star_icon_10@2x.png": 80331,
	"./charmIcon/star_icon_11@2x.png": 32859,
	"./charmIcon/star_icon_12@2x.png": 55158,
	"./charmIcon/star_icon_13@2x.png": 6882,
	"./charmIcon/star_icon_14@2x.png": 66939,
	"./charmIcon/star_icon_15@2x.png": 98413,
	"./charmIcon/star_icon_16@2x.png": 93011,
	"./charmIcon/star_icon_17@2x.png": 17245,
	"./charmIcon/star_icon_18@2x.png": 92075,
	"./charmIcon/star_icon_19@2x.png": 27540,
	"./charmIcon/star_icon_1@2x.png": 42435,
	"./charmIcon/star_icon_20@2x.png": 93532,
	"./charmIcon/star_icon_21@2x.png": 12054,
	"./charmIcon/star_icon_22@2x.png": 24085,
	"./charmIcon/star_icon_23@2x.png": 35624,
	"./charmIcon/star_icon_24@2x.png": 22051,
	"./charmIcon/star_icon_25@2x.png": 37791,
	"./charmIcon/star_icon_26@2x.png": 40311,
	"./charmIcon/star_icon_27@2x.png": 85957,
	"./charmIcon/star_icon_28@2x.png": 66570,
	"./charmIcon/star_icon_29@2x.png": 37261,
	"./charmIcon/star_icon_2@2x.png": 21281,
	"./charmIcon/star_icon_30@2x.png": 67126,
	"./charmIcon/star_icon_31@2x.png": 92015,
	"./charmIcon/star_icon_32@2x.png": 36989,
	"./charmIcon/star_icon_33@2x.png": 98365,
	"./charmIcon/star_icon_34@2x.png": 7910,
	"./charmIcon/star_icon_35@2x.png": 69440,
	"./charmIcon/star_icon_36@2x.png": 52372,
	"./charmIcon/star_icon_37@2x.png": 62649,
	"./charmIcon/star_icon_38@2x.png": 9955,
	"./charmIcon/star_icon_39@2x.png": 89424,
	"./charmIcon/star_icon_3@2x.png": 5484,
	"./charmIcon/star_icon_40@2x.png": 38263,
	"./charmIcon/star_icon_41@2x.png": 93325,
	"./charmIcon/star_icon_42@2x.png": 93479,
	"./charmIcon/star_icon_43@2x.png": 46022,
	"./charmIcon/star_icon_44@2x.png": 75474,
	"./charmIcon/star_icon_45@2x.png": 94632,
	"./charmIcon/star_icon_46@2x.png": 31622,
	"./charmIcon/star_icon_47@2x.png": 26553,
	"./charmIcon/star_icon_48@2x.png": 54182,
	"./charmIcon/star_icon_49@2x.png": 28250,
	"./charmIcon/star_icon_4@2x.png": 51148,
	"./charmIcon/star_icon_50@2x.png": 85299,
	"./charmIcon/star_icon_51@2x.png": 30065,
	"./charmIcon/star_icon_52@2x.png": 13403,
	"./charmIcon/star_icon_53@2x.png": 13113,
	"./charmIcon/star_icon_54@2x.png": 57544,
	"./charmIcon/star_icon_55@2x.png": 64586,
	"./charmIcon/star_icon_56@2x.png": 37110,
	"./charmIcon/star_icon_57@2x.png": 16292,
	"./charmIcon/star_icon_58@2x.png": 25591,
	"./charmIcon/star_icon_59@2x.png": 58008,
	"./charmIcon/star_icon_5@2x.png": 4616,
	"./charmIcon/star_icon_6@2x.png": 57031,
	"./charmIcon/star_icon_7@2x.png": 91281,
	"./charmIcon/star_icon_8@2x.png": 68586,
	"./charmIcon/star_icon_9@2x.png": 98067,
	"./empty_mizhua.png": 28073,
	"./empty_oxygen.png": 79853,
	"./empty_record.png": 68658,
	"./fish_logo.png": 37456,
	"./hydrogen/android.png": 13050,
	"./hydrogen/avatar.png": 4980,
	"./hydrogen/charm/charm_0.png": 9384,
	"./hydrogen/charm/charm_1.png": 97933,
	"./hydrogen/charm/charm_10.png": 88123,
	"./hydrogen/charm/charm_11.png": 75681,
	"./hydrogen/charm/charm_12.png": 40193,
	"./hydrogen/charm/charm_13.png": 74682,
	"./hydrogen/charm/charm_14.png": 54618,
	"./hydrogen/charm/charm_15.png": 44536,
	"./hydrogen/charm/charm_16.png": 68053,
	"./hydrogen/charm/charm_17.png": 3538,
	"./hydrogen/charm/charm_18.png": 10234,
	"./hydrogen/charm/charm_19.png": 93225,
	"./hydrogen/charm/charm_2.png": 62224,
	"./hydrogen/charm/charm_20.png": 23541,
	"./hydrogen/charm/charm_21.png": 42706,
	"./hydrogen/charm/charm_22.png": 13023,
	"./hydrogen/charm/charm_23.png": 820,
	"./hydrogen/charm/charm_24.png": 40464,
	"./hydrogen/charm/charm_25.png": 39419,
	"./hydrogen/charm/charm_26.png": 88973,
	"./hydrogen/charm/charm_27.png": 45563,
	"./hydrogen/charm/charm_28.png": 79785,
	"./hydrogen/charm/charm_29.png": 80357,
	"./hydrogen/charm/charm_3.png": 19588,
	"./hydrogen/charm/charm_30.png": 80160,
	"./hydrogen/charm/charm_31.png": 7171,
	"./hydrogen/charm/charm_32.png": 11842,
	"./hydrogen/charm/charm_33.png": 96775,
	"./hydrogen/charm/charm_34.png": 94163,
	"./hydrogen/charm/charm_35.png": 69253,
	"./hydrogen/charm/charm_36.png": 24360,
	"./hydrogen/charm/charm_37.png": 23401,
	"./hydrogen/charm/charm_38.png": 27301,
	"./hydrogen/charm/charm_39.png": 25769,
	"./hydrogen/charm/charm_4.png": 96157,
	"./hydrogen/charm/charm_40.png": 7355,
	"./hydrogen/charm/charm_41.png": 91293,
	"./hydrogen/charm/charm_42.png": 24401,
	"./hydrogen/charm/charm_43.png": 44376,
	"./hydrogen/charm/charm_44.png": 58470,
	"./hydrogen/charm/charm_45.png": 1843,
	"./hydrogen/charm/charm_46.png": 21030,
	"./hydrogen/charm/charm_47.png": 60961,
	"./hydrogen/charm/charm_48.png": 97250,
	"./hydrogen/charm/charm_49.png": 3482,
	"./hydrogen/charm/charm_5.png": 47926,
	"./hydrogen/charm/charm_50.png": 84314,
	"./hydrogen/charm/charm_51.png": 65339,
	"./hydrogen/charm/charm_52.png": 82562,
	"./hydrogen/charm/charm_53.png": 7312,
	"./hydrogen/charm/charm_54.png": 51899,
	"./hydrogen/charm/charm_55.png": 87620,
	"./hydrogen/charm/charm_56.png": 73335,
	"./hydrogen/charm/charm_57.png": 37533,
	"./hydrogen/charm/charm_58.png": 91979,
	"./hydrogen/charm/charm_59.png": 64105,
	"./hydrogen/charm/charm_6.png": 35818,
	"./hydrogen/charm/charm_60.png": 33283,
	"./hydrogen/charm/charm_7.png": 21926,
	"./hydrogen/charm/charm_8.png": 11604,
	"./hydrogen/charm/charm_9.png": 68719,
	"./hydrogen/empty.png": 76292,
	"./hydrogen/home.png": 29257,
	"./hydrogen/ios.png": 44488,
	"./hydrogen/level/level_0.png": 356,
	"./hydrogen/level/level_1.png": 7028,
	"./hydrogen/level/level_10.png": 73460,
	"./hydrogen/level/level_11.png": 34786,
	"./hydrogen/level/level_12.png": 16032,
	"./hydrogen/level/level_13.png": 41749,
	"./hydrogen/level/level_14.png": 65025,
	"./hydrogen/level/level_15.png": 92147,
	"./hydrogen/level/level_16.png": 11938,
	"./hydrogen/level/level_17.png": 30577,
	"./hydrogen/level/level_18.png": 36943,
	"./hydrogen/level/level_19.png": 36571,
	"./hydrogen/level/level_2.png": 35083,
	"./hydrogen/level/level_20.png": 44207,
	"./hydrogen/level/level_21.png": 46309,
	"./hydrogen/level/level_22.png": 47867,
	"./hydrogen/level/level_23.png": 65733,
	"./hydrogen/level/level_24.png": 73907,
	"./hydrogen/level/level_25.png": 46701,
	"./hydrogen/level/level_26.png": 63200,
	"./hydrogen/level/level_27.png": 296,
	"./hydrogen/level/level_28.png": 78241,
	"./hydrogen/level/level_29.png": 42885,
	"./hydrogen/level/level_3.png": 48565,
	"./hydrogen/level/level_30.png": 47553,
	"./hydrogen/level/level_4.png": 9298,
	"./hydrogen/level/level_5.png": 95091,
	"./hydrogen/level/level_6.png": 23675,
	"./hydrogen/level/level_7.png": 66220,
	"./hydrogen/level/level_8.png": 14756,
	"./hydrogen/level/level_9.png": 71877,
	"./hydrogen/level/level_self.png": 52143,
	"./hydrogen/logo.png": 52188,
	"./hydrogen/wealth/wealth_0.png": 43454,
	"./hydrogen/wealth/wealth_1.png": 24819,
	"./hydrogen/wealth/wealth_10.png": 86882,
	"./hydrogen/wealth/wealth_11.png": 47035,
	"./hydrogen/wealth/wealth_12.png": 50220,
	"./hydrogen/wealth/wealth_13.png": 65111,
	"./hydrogen/wealth/wealth_14.png": 44567,
	"./hydrogen/wealth/wealth_15.png": 96766,
	"./hydrogen/wealth/wealth_16.png": 50801,
	"./hydrogen/wealth/wealth_17.png": 42689,
	"./hydrogen/wealth/wealth_18.png": 15561,
	"./hydrogen/wealth/wealth_19.png": 62147,
	"./hydrogen/wealth/wealth_2.png": 7319,
	"./hydrogen/wealth/wealth_20.png": 57363,
	"./hydrogen/wealth/wealth_21.png": 20321,
	"./hydrogen/wealth/wealth_22.png": 91149,
	"./hydrogen/wealth/wealth_23.png": 58231,
	"./hydrogen/wealth/wealth_24.png": 20977,
	"./hydrogen/wealth/wealth_25.png": 26543,
	"./hydrogen/wealth/wealth_26.png": 30411,
	"./hydrogen/wealth/wealth_27.png": 57832,
	"./hydrogen/wealth/wealth_28.png": 50015,
	"./hydrogen/wealth/wealth_29.png": 60768,
	"./hydrogen/wealth/wealth_3.png": 69962,
	"./hydrogen/wealth/wealth_30.png": 78237,
	"./hydrogen/wealth/wealth_31.png": 43029,
	"./hydrogen/wealth/wealth_32.png": 48657,
	"./hydrogen/wealth/wealth_33.png": 46708,
	"./hydrogen/wealth/wealth_34.png": 65708,
	"./hydrogen/wealth/wealth_35.png": 88004,
	"./hydrogen/wealth/wealth_36.png": 44061,
	"./hydrogen/wealth/wealth_37.png": 24277,
	"./hydrogen/wealth/wealth_38.png": 58242,
	"./hydrogen/wealth/wealth_39.png": 51861,
	"./hydrogen/wealth/wealth_4.png": 25219,
	"./hydrogen/wealth/wealth_40.png": 51836,
	"./hydrogen/wealth/wealth_41.png": 874,
	"./hydrogen/wealth/wealth_42.png": 36490,
	"./hydrogen/wealth/wealth_43.png": 15834,
	"./hydrogen/wealth/wealth_44.png": 82244,
	"./hydrogen/wealth/wealth_45.png": 58870,
	"./hydrogen/wealth/wealth_5.png": 12772,
	"./hydrogen/wealth/wealth_6.png": 30509,
	"./hydrogen/wealth/wealth_7.png": 25321,
	"./hydrogen/wealth/wealth_8.png": 80123,
	"./hydrogen/wealth/wealth_9.png": 58262,
	"./oxygen/android.png": 98584,
	"./oxygen/avatar.png": 83279,
	"./oxygen/empty.png": 49263,
	"./oxygen/home.png": 22437,
	"./oxygen/ios.png": 90572,
	"./oxygen/logo.png": 97507,
	"./oxygen_logo.png": 222,
	"./share.png": 43313,
	"./wealthIcon/wealth_icon_0@2x.png": 88164,
	"./wealthIcon/wealth_icon_10@2x.png": 39932,
	"./wealthIcon/wealth_icon_10_1@2x.png": 60504,
	"./wealthIcon/wealth_icon_11@2x.png": 49774,
	"./wealthIcon/wealth_icon_12@2x.png": 50165,
	"./wealthIcon/wealth_icon_13@2x.png": 26050,
	"./wealthIcon/wealth_icon_14@2x.png": 87071,
	"./wealthIcon/wealth_icon_15@2x.png": 71294,
	"./wealthIcon/wealth_icon_16@2x.png": 91725,
	"./wealthIcon/wealth_icon_17@2x.png": 68511,
	"./wealthIcon/wealth_icon_18@2x.png": 78191,
	"./wealthIcon/wealth_icon_19@2x.png": 23499,
	"./wealthIcon/wealth_icon_1@2x.png": 98461,
	"./wealthIcon/wealth_icon_20@2x.png": 95890,
	"./wealthIcon/wealth_icon_20_1@2x.png": 46963,
	"./wealthIcon/wealth_icon_21@2x.png": 57611,
	"./wealthIcon/wealth_icon_22@2x.png": 63634,
	"./wealthIcon/wealth_icon_23@2x.png": 17113,
	"./wealthIcon/wealth_icon_24@2x.png": 65651,
	"./wealthIcon/wealth_icon_25@2x.png": 66463,
	"./wealthIcon/wealth_icon_26@2x.png": 44941,
	"./wealthIcon/wealth_icon_27@2x.png": 18060,
	"./wealthIcon/wealth_icon_28@2x.png": 295,
	"./wealthIcon/wealth_icon_29@2x.png": 15447,
	"./wealthIcon/wealth_icon_2@2x.png": 88946,
	"./wealthIcon/wealth_icon_30@2x.png": 74574,
	"./wealthIcon/wealth_icon_30_1@2x.png": 43309,
	"./wealthIcon/wealth_icon_31@2x.png": 80251,
	"./wealthIcon/wealth_icon_32@2x.png": 15995,
	"./wealthIcon/wealth_icon_33@2x.png": 22954,
	"./wealthIcon/wealth_icon_34@2x.png": 88509,
	"./wealthIcon/wealth_icon_35@2x.png": 8360,
	"./wealthIcon/wealth_icon_36@2x.png": 60249,
	"./wealthIcon/wealth_icon_37@2x.png": 82838,
	"./wealthIcon/wealth_icon_38@2x.png": 67810,
	"./wealthIcon/wealth_icon_39@2x.png": 57584,
	"./wealthIcon/wealth_icon_3@2x.png": 92636,
	"./wealthIcon/wealth_icon_40@2x.png": 43658,
	"./wealthIcon/wealth_icon_40_1@2x.png": 12156,
	"./wealthIcon/wealth_icon_41@2x.png": 45775,
	"./wealthIcon/wealth_icon_42@2x.png": 88817,
	"./wealthIcon/wealth_icon_43@2x.png": 65579,
	"./wealthIcon/wealth_icon_44@2x.png": 2303,
	"./wealthIcon/wealth_icon_4@2x.png": 40526,
	"./wealthIcon/wealth_icon_5@2x.png": 8211,
	"./wealthIcon/wealth_icon_6@2x.png": 10853,
	"./wealthIcon/wealth_icon_7@2x.png": 46928,
	"./wealthIcon/wealth_icon_8@2x.png": 32512,
	"./wealthIcon/wealth_icon_9@2x.png": 68383,
	"./yoyo/android.png": 48277,
	"./yoyo/avatar.png": 68214,
	"./yoyo/charm/charm_0.png": 98517,
	"./yoyo/charm/charm_1.png": 47300,
	"./yoyo/charm/charm_10.png": 45107,
	"./yoyo/charm/charm_11.png": 29196,
	"./yoyo/charm/charm_12.png": 11605,
	"./yoyo/charm/charm_13.png": 34583,
	"./yoyo/charm/charm_14.png": 43314,
	"./yoyo/charm/charm_15.png": 84558,
	"./yoyo/charm/charm_16.png": 78222,
	"./yoyo/charm/charm_17.png": 69427,
	"./yoyo/charm/charm_18.png": 27284,
	"./yoyo/charm/charm_19.png": 43285,
	"./yoyo/charm/charm_2.png": 45353,
	"./yoyo/charm/charm_20.png": 47571,
	"./yoyo/charm/charm_21.png": 63909,
	"./yoyo/charm/charm_22.png": 69872,
	"./yoyo/charm/charm_23.png": 83258,
	"./yoyo/charm/charm_24.png": 43121,
	"./yoyo/charm/charm_25.png": 87710,
	"./yoyo/charm/charm_26.png": 42541,
	"./yoyo/charm/charm_27.png": 76176,
	"./yoyo/charm/charm_28.png": 26052,
	"./yoyo/charm/charm_29.png": 92479,
	"./yoyo/charm/charm_3.png": 94023,
	"./yoyo/charm/charm_30.png": 67567,
	"./yoyo/charm/charm_31.png": 77697,
	"./yoyo/charm/charm_32.png": 96437,
	"./yoyo/charm/charm_33.png": 80002,
	"./yoyo/charm/charm_34.png": 9050,
	"./yoyo/charm/charm_35.png": 10560,
	"./yoyo/charm/charm_36.png": 36728,
	"./yoyo/charm/charm_37.png": 89030,
	"./yoyo/charm/charm_38.png": 99659,
	"./yoyo/charm/charm_39.png": 69206,
	"./yoyo/charm/charm_4.png": 23587,
	"./yoyo/charm/charm_40.png": 17508,
	"./yoyo/charm/charm_41.png": 32622,
	"./yoyo/charm/charm_42.png": 94055,
	"./yoyo/charm/charm_43.png": 3052,
	"./yoyo/charm/charm_44.png": 59978,
	"./yoyo/charm/charm_45.png": 10950,
	"./yoyo/charm/charm_46.png": 43931,
	"./yoyo/charm/charm_47.png": 62406,
	"./yoyo/charm/charm_48.png": 27028,
	"./yoyo/charm/charm_49.png": 55814,
	"./yoyo/charm/charm_5.png": 43821,
	"./yoyo/charm/charm_50.png": 32724,
	"./yoyo/charm/charm_51.png": 74294,
	"./yoyo/charm/charm_52.png": 54387,
	"./yoyo/charm/charm_53.png": 50882,
	"./yoyo/charm/charm_54.png": 42208,
	"./yoyo/charm/charm_55.png": 65569,
	"./yoyo/charm/charm_56.png": 75579,
	"./yoyo/charm/charm_57.png": 86070,
	"./yoyo/charm/charm_58.png": 55066,
	"./yoyo/charm/charm_59.png": 76812,
	"./yoyo/charm/charm_6.png": 11868,
	"./yoyo/charm/charm_60.png": 92735,
	"./yoyo/charm/charm_7.png": 83983,
	"./yoyo/charm/charm_8.png": 88438,
	"./yoyo/charm/charm_9.png": 65684,
	"./yoyo/empty.png": 35899,
	"./yoyo/home.png": 40893,
	"./yoyo/ios.png": 44371,
	"./yoyo/level/level_0.png": 37714,
	"./yoyo/level/level_1.png": 90358,
	"./yoyo/level/level_10.png": 75948,
	"./yoyo/level/level_11.png": 20594,
	"./yoyo/level/level_12.png": 94291,
	"./yoyo/level/level_13.png": 20521,
	"./yoyo/level/level_14.png": 55805,
	"./yoyo/level/level_15.png": 22346,
	"./yoyo/level/level_16.png": 60954,
	"./yoyo/level/level_17.png": 31654,
	"./yoyo/level/level_18.png": 65460,
	"./yoyo/level/level_19.png": 75405,
	"./yoyo/level/level_2.png": 98997,
	"./yoyo/level/level_20.png": 81466,
	"./yoyo/level/level_21.png": 21887,
	"./yoyo/level/level_22.png": 43462,
	"./yoyo/level/level_23.png": 74066,
	"./yoyo/level/level_24.png": 92244,
	"./yoyo/level/level_25.png": 13944,
	"./yoyo/level/level_26.png": 40759,
	"./yoyo/level/level_27.png": 71049,
	"./yoyo/level/level_28.png": 12261,
	"./yoyo/level/level_29.png": 78285,
	"./yoyo/level/level_3.png": 90489,
	"./yoyo/level/level_30.png": 52061,
	"./yoyo/level/level_4.png": 61346,
	"./yoyo/level/level_5.png": 17765,
	"./yoyo/level/level_6.png": 13355,
	"./yoyo/level/level_7.png": 20005,
	"./yoyo/level/level_8.png": 55352,
	"./yoyo/level/level_9.png": 28610,
	"./yoyo/level/level_self.png": 65020,
	"./yoyo/logo.png": 62361,
	"./yoyo/wealth/wealth_0.png": 61355,
	"./yoyo/wealth/wealth_1.png": 42153,
	"./yoyo/wealth/wealth_10.png": 98000,
	"./yoyo/wealth/wealth_11.png": 54392,
	"./yoyo/wealth/wealth_12.png": 51101,
	"./yoyo/wealth/wealth_13.png": 8637,
	"./yoyo/wealth/wealth_14.png": 98975,
	"./yoyo/wealth/wealth_15.png": 51248,
	"./yoyo/wealth/wealth_16.png": 3757,
	"./yoyo/wealth/wealth_17.png": 514,
	"./yoyo/wealth/wealth_18.png": 50883,
	"./yoyo/wealth/wealth_19.png": 61477,
	"./yoyo/wealth/wealth_2.png": 45939,
	"./yoyo/wealth/wealth_20.png": 67026,
	"./yoyo/wealth/wealth_21.png": 37422,
	"./yoyo/wealth/wealth_22.png": 21907,
	"./yoyo/wealth/wealth_23.png": 57475,
	"./yoyo/wealth/wealth_24.png": 61881,
	"./yoyo/wealth/wealth_25.png": 87727,
	"./yoyo/wealth/wealth_26.png": 85951,
	"./yoyo/wealth/wealth_27.png": 11595,
	"./yoyo/wealth/wealth_28.png": 31520,
	"./yoyo/wealth/wealth_29.png": 15541,
	"./yoyo/wealth/wealth_3.png": 95470,
	"./yoyo/wealth/wealth_30.png": 11588,
	"./yoyo/wealth/wealth_31.png": 38055,
	"./yoyo/wealth/wealth_32.png": 85823,
	"./yoyo/wealth/wealth_33.png": 19455,
	"./yoyo/wealth/wealth_34.png": 26763,
	"./yoyo/wealth/wealth_35.png": 65311,
	"./yoyo/wealth/wealth_36.png": 36220,
	"./yoyo/wealth/wealth_37.png": 36298,
	"./yoyo/wealth/wealth_38.png": 75735,
	"./yoyo/wealth/wealth_39.png": 69664,
	"./yoyo/wealth/wealth_4.png": 90517,
	"./yoyo/wealth/wealth_40.png": 24584,
	"./yoyo/wealth/wealth_41.png": 19924,
	"./yoyo/wealth/wealth_42.png": 46622,
	"./yoyo/wealth/wealth_43.png": 15618,
	"./yoyo/wealth/wealth_44.png": 24560,
	"./yoyo/wealth/wealth_45.png": 82640,
	"./yoyo/wealth/wealth_5.png": 42364,
	"./yoyo/wealth/wealth_6.png": 79405,
	"./yoyo/wealth/wealth_7.png": 35776,
	"./yoyo/wealth/wealth_8.png": 90502,
	"./yoyo/wealth/wealth_9.png": 25690,
	"./zhua_logo.png": 86456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31137;